// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mr-2";
export var interactiveWrapper = "_mr-0";
export var shippingHoverPreview = "_mr-4";
export var summaryBadgeTrigger = "_mr-1";
export var widgetHoverPreviewList = "_mr-3";
export var widgetPreviewScale = "_mr-5";